/* =====================================================================
   HOOPSTARS — comportements des sections « hs-* »
   ===================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('hs-config');
  var CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
  var TXT = CFG.texts || {};
  var FREE = parseInt(CFG.freeShip, 10) || 2;
  var GIFT = parseInt(CFG.gift, 10) || 3;
  var cartCount = parseInt(CFG.cartCount, 10) || 0;
  var mqMobile = window.matchMedia('(max-width: 749px)');

  /* ---------- Utilitaires ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) {
    if (!el || el.hasAttribute('data-hs-init-' + key)) return false;
    el.setAttribute('data-hs-init-' + key, '');
    return true;
  }
  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    if ((CFG.currency || 'EUR') === 'EUR') {
      var parts = v.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, String.fromCharCode(0x202f));
      return parts[0] + ',' + parts[1] + String.fromCharCode(0xa0) + '€';
    }
    try {
      return new Intl.NumberFormat(CFG.locale || 'fr', { style: 'currency', currency: CFG.currency }).format(v);
    } catch (e) { return v.toFixed(2); }
  }
  function plural(n, one, many) { return n + ' ' + (n > 1 ? many : one); }
  function isColorName(name) { return /couleur|color|coloris/i.test(name || ''); }
  function colorFor(value) {
    var n = String(value || '').toLowerCase();
    var map = [
      [/noir|black/, '#111111'], [/blanc|white|ivoire/, '#FFFFFF'], [/gris|grey|gray/, '#8A8A8A'],
      [/marine|navy/, '#1F2A44'], [/bleu|blue|sarcelle|canard/, '#2F4B8C'], [/rouge|red/, '#C0392B'],
      [/orange/, '#F26B1D'], [/rose|pink/, '#E8A0B4'], [/vert|green/, '#2E7D4F'],
      [/violet|mauve|purple/, '#7B5EA7'], [/jaune|yellow/, '#F2C94C'], [/^or$|gold/, '#C9A227'], [/beige|sable/, '#D9C3A0']
    ];
    for (var i = 0; i < map.length; i++) { if (map[i][0].test(n)) return map[i][1]; }
    return '#BDBDBD';
  }
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }

  /* ---------- Panier ---------- */
  function cartSectionIds() {
    var ids = [];
    $$('[data-hs-cart-section], cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-hs-cart-section') || el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function openCart() {
    // Tiroir « HS · Panier » (sections/hs-cart.liquid) en priorité
    try {
      if (window.HSCart && typeof window.HSCart.open === 'function' && window.HSCart.open()) return true;
    } catch (e) { /* on continue */ }
    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') {
        if (typeof window.kachingCartApi.refreshCart === 'function') {
          var r = window.kachingCartApi.refreshCart();
          if (r && typeof r.then === 'function') {
            r.then(function () { window.kachingCartApi.openCart(); }, function () { window.kachingCartApi.openCart(); });
            return true;
          }
        }
        window.kachingCartApi.openCart();
        return true;
      }
    } catch (e) { /* on continue avec le tiroir du thème */ }
    var drawer = $('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      if (!drawer.hasAttribute('auto-open')) drawer.open();
      return true;
    }
    return false;
  }

  function addToCart(items) {
    var sections = cartSectionIds();
    var body = { items: items.map(function (i) { return { id: Number(i.id), quantity: i.quantity || 1 }; }) };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    return fetch(CFG.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          var err = new Error(r.data.description || r.data.message || TXT.error || 'Erreur');
          throw err;
        }
        return fetch(CFG.cartJsUrl || '/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .catch(function () { return null; })
          .then(function (cart) {
            if (cart && typeof cart.item_count === 'number') cartCount = cart.item_count;
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart || {}, sourceId: 'hs', data: { source: 'hs', itemCount: cartCount, sections: r.data.sections } }
            }));
            document.dispatchEvent(new CustomEvent('hs:cart-changed', { detail: { count: cartCount } }));
            openCart();
            return r.data;
          });
      });
  }

  // Les autres modules du thème (tiroir, applis) mettent aussi à jour le panier
  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data;
    if (!d || d.source === 'hs') return;
    if (d.source === 'product-form-component') {
      cartCount += Number(d.itemCount) || 0;
    } else if (typeof d.itemCount === 'number') {
      cartCount = d.itemCount;
    }
    document.dispatchEvent(new CustomEvent('hs:cart-changed', { detail: { count: cartCount } }));
  });

  function setBtnState(btn, state, label) {
    if (!btn) return;
    if (state === 'loading') { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    else { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    if (label != null) btn.textContent = label;
  }

  /* ---------- Barre d'annonce (mobile : défilement) ---------- */
  function initAnnounce(root) {
    $$('[data-hs-announce]', root).forEach(function (bar) {
      if (!once(bar, 'announce')) return;
      var msgs = $$('.hs-announce__msg', bar);
      if (msgs.length < 2) return;
      var i = 0;
      var delay = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
      setInterval(function () {
        if (!mqMobile.matches || document.hidden) return;
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, delay);
    });
  }

  /* ---------- En-tête ---------- */
  function closeDrawer(d) {
    if (!d) return;
    if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open');
  }
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-hs-drawer-open]');
    if (openBtn) {
      var d = document.getElementById(openBtn.getAttribute('data-hs-drawer-open'));
      if (d) {
        if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('hs-lock');
        d.addEventListener('close', function onClose() {
          document.documentElement.classList.remove('hs-lock');
          $$('[data-hs-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
          d.removeEventListener('close', onClose);
        });
      }
      return;
    }
    var closeBtn = e.target.closest('[data-hs-drawer-close]');
    if (closeBtn) { closeDrawer(closeBtn.closest('dialog')); return; }

    var cartLink = e.target.closest('[data-hs-drawer-cart]');
    if (cartLink) {
      closeDrawer(cartLink.closest('dialog'));
      if (openCart()) e.preventDefault();
      return;
    }
    var drawerLink = e.target.closest('.hs-drawer a');
    if (drawerLink) { closeDrawer(drawerLink.closest('dialog')); }

    // clic sur le fond d'une fenêtre (guide des tailles, ajout rapide)
    if (e.target.matches && e.target.matches('dialog.hs-sheet, dialog.hs-qa')) {
      closeDrawer(e.target);
      return;
    }
    var dlgClose = e.target.closest('[data-hs-dialog-close]');
    if (dlgClose) { closeDrawer(dlgClose.closest('dialog')); }
  });

  var lastScrolled = null;
  function onScrollHeader() {
    var scrolled = window.scrollY > 8;
    if (scrolled === lastScrolled) return;
    lastScrolled = scrolled;
    $$('[data-hs-header]').forEach(function (h) { h.classList.toggle('is-scrolled', scrolled); });
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });

  /* ---------- Onglets (grille produits) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-hs-tab]');
    if (!tab) return;
    var root = tab.closest('[data-hs-tabs-root]');
    if (!root) return;
    $$('[data-hs-tab]', root).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    $$('.hs-products__panel', root).forEach(function (p) { p.hidden = p.id !== tab.getAttribute('data-hs-tab'); });
  });

  /* ---------- Vidéos UGC ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hs-ugc-play]');
    if (!btn) return;
    var tile = btn.closest('[data-hs-ugc-tile]');
    var video = tile && $('video', tile);
    if (!video) return;
    if (video.paused) {
      $$('[data-hs-ugc-tile] video').forEach(function (v) { if (v !== video) { v.pause(); v.closest('[data-hs-ugc-tile]').classList.remove('is-playing'); } });
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      tile.classList.add('is-playing');
      btn.setAttribute('aria-label', 'Mettre la vidéo en pause');
    } else {
      video.pause();
      tile.classList.remove('is-playing');
      btn.setAttribute('aria-label', 'Lire la vidéo');
    }
  });

  /* ---------- Dates de livraison ---------- */
  function initDelivery(root) {
    $$('[data-hs-delivery]', root).forEach(function (box) {
      var min = parseInt(box.getAttribute('data-min'), 10) || parseInt(CFG.deliveryMin, 10) || 8;
      var max = parseInt(box.getAttribute('data-max'), 10) || parseInt(CFG.deliveryMax, 10) || 15;
      var now = new Date();
      var d1 = fmtDate(addBusinessDays(now, min));
      var d2 = fmtDate(addBusinessDays(now, max));
      $$('[data-hs-delivery-line]', box).forEach(function (line) {
        var tpl = line.getAttribute('data-template') || '';
        // « 19 oct. » en fin de phrase : pas de double point
        line.textContent = tpl.replace('[date1]', d1).replace('[date2]', d2).replace(/([^.])\.\.(?!\.)/g, '$1.');
      });
    });
  }

  /* ---------- Sélection de variante (commun) ---------- */
  function findVariant(product, opts) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] != null && opts[j] !== '' && v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function isComplete(opts, product) {
    for (var j = 0; j < product.options.length; j++) { if (opts[j] == null || opts[j] === '') return false; }
    return true;
  }
  function firstAvailable(product, opts) {
    var best = null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] != null && opts[j] !== '' && v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) { if (v.available) return v; if (!best) best = v; }
    }
    return best || product.variants[0];
  }
  function uniqueValues(product, idx) {
    var out = [];
    product.variants.forEach(function (v) { if (out.indexOf(v.options[idx]) === -1) out.push(v.options[idx]); });
    return out;
  }

  /* ---------- Ajout rapide (cartes produit) ---------- */
  var qaDialog = null;
  function getQaDialog() {
    if (qaDialog) return qaDialog;
    qaDialog = document.createElement('dialog');
    qaDialog.className = 'hs hs-qa';
    qaDialog.setAttribute('aria-label', 'Ajout rapide');
    document.body.appendChild(qaDialog);
    return qaDialog;
  }
  function renderQa(product) {
    var dlg = getQaDialog();
    var opts = product.options.map(function (name, idx) {
      var vals = uniqueValues(product, idx);
      if (vals.length === 1) return vals[0];
      if (isColorName(name)) return firstAvailable(product, []).options[idx];
      return '';
    });
    function html() {
      var v = isComplete(opts, product) ? findVariant(product, opts) : firstAvailable(product, opts);
      var img = (v && v.featured_image && v.featured_image.src) || (product.featured_image || '');
      var h = '<div class="hs-qa__inner">';
      h += '<div class="hs-qa__top"><span class="hs-qa__thumb">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="">' : '') + '</span>';
      h += '<div><p class="hs-qa__name">' + esc(product.title) + '</p><p class="hs-qa__price">' + money(v ? v.price : product.price) + '</p></div>';
      h += '<button type="button" class="hs-icon-btn hs-qa__close" data-hs-dialog-close aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
      product.options.forEach(function (name, idx) {
        var vals = uniqueValues(product, idx);
        if (vals.length < 2) return;
        if (isColorName(name)) {
          h += '<div class="hs-opt"><p class="hs-opt__label">' + esc(name) + ' : <span>' + esc(opts[idx] || '') + '</span></p><div class="hs-opt__swatches">';
          vals.forEach(function (val) {
            h += '<button type="button" class="hs-swatch-btn" data-qa-opt="' + idx + '" data-value="' + esc(val) + '" aria-label="' + esc(val) + '" aria-pressed="' + (opts[idx] === val) + '"><span style="--sw:' + colorFor(val) + '"></span></button>';
          });
          h += '</div></div>';
        } else {
          h += '<div class="hs-opt"><p class="hs-opt__label">' + esc(name) + (opts[idx] ? ' : <span>' + esc(opts[idx]) + '</span>' : '') + '</p><div class="hs-sizes">';
          vals.forEach(function (val) {
            var test = opts.slice(); test[idx] = val;
            var tv = firstAvailable(product, test);
            var avail = tv && tv.available && tv.options[idx] === val;
            h += '<button type="button" class="hs-size' + (avail ? '' : ' is-unavailable') + '" data-qa-opt="' + idx + '" data-value="' + esc(val) + '" aria-pressed="' + (opts[idx] === val) + '">' + esc(val) + '</button>';
          });
          h += '</div></div>';
        }
      });
      var complete = isComplete(opts, product);
      var avail = complete && v && v.available;
      h += '<p class="hs-qa__error" data-qa-error hidden></p>';
      h += '<button type="button" class="hs-btn hs-btn--orange hs-btn--block" data-qa-add' + (complete && !avail ? ' disabled' : '') + '>' +
        (complete ? (avail ? 'Ajouter au panier · ' + money(v.price) : esc(TXT.soldOut || 'Épuisé')) : 'Choisis ta taille') + '</button>';
      h += '</div>';
      dlg.innerHTML = h;
    }
    html();
    dlg.onclick = function (e) {
      var b = e.target.closest('[data-qa-opt]');
      if (b) { opts[Number(b.getAttribute('data-qa-opt'))] = b.getAttribute('data-value'); html(); return; }
      var add = e.target.closest('[data-qa-add]');
      if (add) {
        if (!isComplete(opts, product)) {
          var err = $('[data-qa-error]', dlg);
          if (err) { err.textContent = TXT.chooseSize || 'Choisis ta taille pour continuer.'; err.hidden = false; }
          return;
        }
        var v = findVariant(product, opts);
        if (!v || !v.available) return;
        setBtnState(add, 'loading');
        addToCart([{ id: v.id, quantity: 1 }]).then(function () {
          closeDrawer(dlg);
        }).catch(function (er) {
          setBtnState(add, 'idle');
          var e2 = $('[data-qa-error]', dlg);
          if (e2) { e2.textContent = er.message; e2.hidden = false; }
        });
      }
    };
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hs-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-variant-id');
    if (vid) {
      btn.disabled = true;
      addToCart([{ id: vid, quantity: 1 }]).then(function () {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; }, 1600);
      }).catch(function () { btn.disabled = false; window.location.href = btn.getAttribute('data-url'); });
      return;
    }
    var handle = btn.getAttribute('data-handle');
    btn.disabled = true;
    fetch((CFG.root && CFG.root !== '/' ? CFG.root : '') + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
      .then(function (product) {
        // /products/x.js renvoie des options objets ({ name, values }) : on garde les noms
        product.options = (product.options || []).map(function (o) { return o && typeof o === 'object' ? o.name : o; });
        btn.disabled = false;
        renderQa(product);
      })
      .catch(function () { btn.disabled = false; window.location.href = btn.getAttribute('data-url'); });
  });

  /* ---------- Compose ta tenue ---------- */
  function initTenue(root) {
    $$('[data-hs-tenue]', root).forEach(function (sec) {
      if (!once(sec, 'tenue')) return;
      var steps = $$('[data-hs-step]', sec).map(function (el) {
        var products = parseJSON($('[data-hs-step-data]', el)) || [];
        var st = { el: el, products: products, pIndex: 0, opts: [] };
        resetOpts(st);
        return st;
      });
      var msg = $('[data-hs-tenue-msg]', sec);

      function resetOpts(st) {
        var p = st.products[st.pIndex];
        if (!p) { st.opts = []; return; }
        var fa = firstAvailable(p, []);
        st.opts = p.options.map(function (name, idx) {
          var vals = uniqueValues(p, idx);
          if (vals.length === 1) return vals[0];
          if (isColorName(name)) return fa ? fa.options[idx] : vals[0];
          return '';
        });
      }
      function current(st) {
        var p = st.products[st.pIndex];
        if (!p) return null;
        return isComplete(st.opts, p) ? findVariant(p, st.opts) : firstAvailable(p, st.opts);
      }
      function renderOpts(st) {
        var p = st.products[st.pIndex];
        var box = $('[data-hs-step-opts]', st.el);
        if (!p || !box) return;
        var h = '';
        p.options.forEach(function (name, idx) {
          var vals = uniqueValues(p, idx);
          if (vals.length < 2) return;
          if (isColorName(name)) {
            h += '<div class="hs-step__colors" role="group" aria-label="' + esc(name) + '" data-hs-opt="' + idx + '">';
            vals.forEach(function (val) {
              h += '<button type="button" class="hs-swatch-btn" aria-label="' + esc(val) + '" aria-pressed="' + (st.opts[idx] === val) + '" data-hs-val="' + esc(val) + '"><span style="--sw:' + colorFor(val) + '"></span></button>';
            });
            h += '</div>';
          } else {
            h += '<div class="hs-step__sizewrap"><span class="hs-step__sizelabel">' + esc(name) + '</span><select class="hs-select' + (st.opts[idx] ? ' has-value' : '') + '" aria-label="' + esc(name) + '" data-hs-opt="' + idx + '"><option value="">Choisir</option>';
            vals.forEach(function (val) {
              var test = st.opts.slice(); test[idx] = val;
              var tv = findVariant(p, test);
              var dis = tv && !tv.available;
              h += '<option value="' + esc(val) + '"' + (st.opts[idx] === val ? ' selected' : '') + (dis ? ' disabled' : '') + '>' + esc(val) + (dis ? ' · ' + esc(TXT.soldOut || 'épuisé') : '') + '</option>';
            });
            h += '</select></div>';
          }
        });
        box.innerHTML = h;
      }
      function renderStep(st) {
        var p = st.products[st.pIndex];
        if (!p) return;
        var v = current(st);
        var name = $('[data-hs-step-name]', st.el);
        if (name) name.textContent = p.title;
        $$('[data-hs-step-price]', st.el).forEach(function (el) { el.textContent = money(v ? v.price : 0); });
        var img = $('[data-hs-step-media] img', st.el);
        var src = (v && v.image) || p.image;
        if (img && src) { img.removeAttribute('srcset'); img.src = src; img.alt = p.title; }
        $$('.hs-step__choices [data-hs-choice]', st.el).forEach(function (b) {
          b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-hs-choice')) === st.pIndex));
        });
        $$('.hs-step__change [data-hs-choice]', st.el).forEach(function (b) {
          b.hidden = Number(b.getAttribute('data-hs-choice')) === st.pIndex;
        });
      }
      function total() {
        var t = 0;
        steps.forEach(function (st) { var v = current(st); if (v) t += v.price; });
        return t;
      }
      function renderTotal() {
        var t = money(total());
        $$('[data-hs-tenue-total]', sec).forEach(function (el) { el.textContent = t; });
      }

      steps.forEach(function (st) {
        st.el.addEventListener('click', function (e) {
          var ch = e.target.closest('[data-hs-choice]');
          if (ch) {
            st.pIndex = Number(ch.getAttribute('data-hs-choice')) || 0;
            resetOpts(st);
            renderOpts(st); renderStep(st); renderTotal();
            if (msg) msg.textContent = '';
            return;
          }
          var sw = e.target.closest('[data-hs-val]');
          if (sw) {
            var group = sw.closest('[data-hs-opt]');
            var idx = Number(group.getAttribute('data-hs-opt'));
            st.opts[idx] = sw.getAttribute('data-hs-val');
            renderOpts(st); renderStep(st); renderTotal();
          }
        });
        st.el.addEventListener('change', function (e) {
          var sel = e.target.closest('select[data-hs-opt]');
          if (!sel) return;
          st.opts[Number(sel.getAttribute('data-hs-opt'))] = sel.value;
          sel.classList.toggle('has-value', !!sel.value);
          sel.classList.remove('is-error');
          renderOpts(st); renderStep(st); renderTotal();
          if (msg) msg.textContent = '';
        });
        renderOpts(st);
        renderStep(st);
      });
      renderTotal();

      $$('[data-hs-tenue-add]', sec).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var items = [];
          var missing = false;
          steps.forEach(function (st) {
            var p = st.products[st.pIndex];
            if (!p) return;
            if (!isComplete(st.opts, p)) {
              missing = true;
              $$('select[data-hs-opt]', st.el).forEach(function (s) { if (!s.value) s.classList.add('is-error'); });
              return;
            }
            var v = findVariant(p, st.opts);
            if (!v || !v.available) { missing = true; return; }
            items.push({ id: v.id, quantity: 1 });
          });
          if (missing || !items.length) {
            if (msg) msg.textContent = TXT.chooseAll || 'Choisis une taille pour chaque article.';
            var firstErr = $('.is-error', sec);
            if (firstErr) firstErr.focus();
            return;
          }
          var label = btn.innerHTML;
          setBtnState(btn, 'loading');
          addToCart(items).then(function () {
            setBtnState(btn, 'idle');
            btn.textContent = (TXT.added || 'Ajouté') + ' ✓';
            if (msg) msg.textContent = '';
            setTimeout(function () { btn.innerHTML = label; renderTotal(); }, 1800);
          }).catch(function (er) {
            setBtnState(btn, 'idle');
            btn.innerHTML = label;
            if (msg) msg.textContent = er.message || TXT.error;
          });
        });
      });
    });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(root) {
    $$('[data-hs-product]', root).forEach(function (sec) {
      if (!once(sec, 'product')) return;
      var product = parseJSON($('[data-hs-product-json]', sec));
      if (!product) return;
      var needsChoice = sec.getAttribute('data-needs-choice') === 'true';
      var input = $('[data-hs-variant-input]', sec);
      var atc = $('[data-hs-atc]', sec);
      var atcMsg = $('[data-hs-atc-msg]', sec);
      var form = $('[data-hs-form]', sec) || (atc && atc.form);
      var sticky = $('[data-hs-sticky]', sec);
      var colorIndex = product.colorIndex;

      var startVariant = null;
      product.variants.forEach(function (v) { if (input && String(v.id) === String(input.value)) startVariant = v; });
      if (!startVariant) startVariant = firstAvailable(product, []);
      var opts = product.options.map(function (name, idx) {
        var vals = uniqueValues(product, idx);
        if (vals.length === 1) return vals[0];
        if (idx === colorIndex || !needsChoice) return startVariant ? startVariant.options[idx] : '';
        return '';
      });

      function currentVariant() { return isComplete(opts, product) ? findVariant(product, opts) : null; }
      function displayVariant() { return currentVariant() || firstAvailable(product, opts); }

      function addonRows() { return $$('[data-hs-addon]', sec); }
      function checkedAddons() { return addonRows().filter(function (r) { var c = $('[data-hs-addon-check]', r); return c && c.checked; }); }
      function addonPrice(row) {
        var sel = $('select[data-hs-addon-variant]', row);
        if (sel) { var o = sel.options[sel.selectedIndex]; return o ? Number(o.getAttribute('data-price')) || 0 : 0; }
        var priceEl = $('[data-hs-addon-price]', row);
        return priceEl ? Number(priceEl.getAttribute('data-cents')) || 0 : 0;
      }

      function updateOptionsUI() {
        $$('[data-hs-option]', sec).forEach(function (group) {
          var idx = Number(group.getAttribute('data-hs-option'));
          var isColor = group.getAttribute('data-type') === 'color';
          var valueEl = $('[data-hs-opt-value]', group);
          if (valueEl) valueEl.textContent = isColor ? (opts[idx] || '') : (opts[idx] ? ' : ' + opts[idx] : '');
          $$('button[data-value]', group).forEach(function (b) {
            var val = b.getAttribute('data-value');
            b.setAttribute('aria-pressed', String(opts[idx] === val));
            if (!isColor) {
              var avail = false;
              product.variants.forEach(function (v) {
                var ok = v.options[idx] === val;
                if (ok && colorIndex > -1 && opts[colorIndex]) ok = v.options[colorIndex] === opts[colorIndex];
                if (ok && v.available) avail = true;
              });
              b.classList.toggle('is-unavailable', !avail);
            }
          });
        });
      }

      function updatePrice(v) {
        var price = $('[data-hs-price]', sec);
        var cmp = $('[data-hs-compare]', sec);
        if (price && v) price.textContent = money(v.price);
        if (cmp) {
          if (v && v.compare > v.price) { cmp.textContent = money(v.compare); cmp.hidden = false; }
          else { cmp.hidden = true; }
        }
      }

      function totals() {
        var v = displayVariant();
        var count = 1;
        var sum = v ? v.price : 0;
        checkedAddons().forEach(function (r) { count += 1; sum += addonPrice(r); });
        return { count: count, sum: sum };
      }

      function updateATC() {
        if (!atc) return;
        var v = currentVariant();
        var t = totals();
        var label = atc.getAttribute('data-label') || 'Ajouter au panier';
        var multi = atc.getAttribute('data-label-multi') || 'Ajouter [n] articles';
        if (v && !v.available) {
          atc.disabled = true;
          atc.textContent = atc.getAttribute('data-label-soldout') || TXT.soldOut || 'Épuisé';
        } else {
          atc.disabled = false;
          atc.textContent = (t.count > 1 ? multi.replace('[n]', t.count) : label) + ' · ' + money(t.sum);
        }
      }

      function updateOffer() {
        var t = totals();
        var count = cartCount + t.count;
        $$('[data-hs-offer]', sec).forEach(function (box) {
          var msgEl = $('[data-hs-offer-msg]', box);
          var tpl;
          if (count >= GIFT) tpl = box.getAttribute('data-msg2');
          else if (count >= FREE) tpl = box.getAttribute('data-msg1');
          else tpl = box.getAttribute('data-msg0');
          var n1 = Math.max(FREE - count, 0);
          var n2 = Math.max(GIFT - count, 0);
          if (msgEl && tpl != null) {
            msgEl.innerHTML = esc(tpl)
              .replace('[n1]', '<strong>' + esc(plural(n1, 'article', 'articles')) + '</strong>')
              .replace('[n2]', '<strong>' + esc(plural(n2, 'article', 'articles')) + '</strong>');
          }
          $$('[data-hs-seg]', box).forEach(function (seg) {
            var need = seg.getAttribute('data-hs-seg') === '2' ? FREE : GIFT;
            seg.classList.toggle('is-on', count >= need);
          });
        });
      }

      function updateGallery(v) {
        if (!v) return;
        var mid = v.media ? String(v.media) : '';
        if (!mid || mid === '0') return;
        var main = $('[data-hs-main-media]', sec);
        if (main && main.getAttribute('data-media-id') !== mid && v.imageLarge) {
          var img = $('img', main);
          if (img) { img.removeAttribute('srcset'); img.src = v.imageLarge; }
          main.setAttribute('data-media-id', mid);
        }
        var track = $('[data-hs-track]', sec);
        var slide = track && $('.hs-gallery__slide[data-media-id="' + mid + '"]', track);
        if (track && slide && mqMobile.matches) {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }

      function updateSticky() {
        if (!sticky) return;
        var v = displayVariant();
        var nameEl = $('[data-hs-sticky-name]', sticky);
        var subEl = $('[data-hs-sticky-sub]', sticky);
        var btn = $('[data-hs-sticky-btn]', sticky);
        var img = $('.hs-sticky-atc__thumb img', sticky);
        if (nameEl) nameEl.textContent = product.title + (colorIndex > -1 && opts[colorIndex] ? ' · ' + opts[colorIndex] : '');
        var missing = !isComplete(opts, product);
        var sizeTxt = '';
        if (missing) sizeTxt = (sticky.getAttribute('data-choose-text') || 'Taille à choisir') + ' · ';
        else {
          var parts = [];
          product.options.forEach(function (n, j) { if (j !== colorIndex && uniqueValues(product, j).length > 1) parts.push(n + ' ' + opts[j]); });
          if (parts.length) sizeTxt = parts.join(' · ') + ' · ';
        }
        if (subEl) subEl.textContent = sizeTxt + money(totals().sum);
        if (btn) btn.textContent = missing ? btn.getAttribute('data-label-choose') : btn.getAttribute('data-label-add');
        if (img && v && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
      }

      function updateURL(v) {
        if (!v || !window.history || !window.history.replaceState) return;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) { /* rien */ }
      }

      function syncAddons() {
        // Propose la même taille (et la couleur préférée) pour les produits complémentaires
        var box = $('[data-hs-addons]', sec);
        var prefer = box ? (box.getAttribute('data-prefer-color') || '').toLowerCase() : '';
        var sizeVals = [];
        product.options.forEach(function (n, j) { if (j !== colorIndex && opts[j]) sizeVals.push(String(opts[j]).toLowerCase()); });
        addonRows().forEach(function (row) {
          var sel = $('select[data-hs-addon-variant]', row);
          if (!sel || row.hasAttribute('data-user-picked')) return;
          var best = -1, bestScore = -1;
          Array.prototype.forEach.call(sel.options, function (o, i) {
            if (o.disabled) return;
            var vals = (o.getAttribute('data-options') || '').toLowerCase().split('||');
            var score = 0;
            sizeVals.forEach(function (sv) { if (vals.indexOf(sv) > -1) score += 2; });
            if (prefer && vals.indexOf(prefer) > -1) score += 1;
            if (score > bestScore) { bestScore = score; best = i; }
          });
          if (best > -1) sel.selectedIndex = best;
          var pe = $('[data-hs-addon-price]', row);
          if (pe) pe.textContent = money(addonPrice(row));
        });
      }

      function refresh(changedColor, initial) {
        var v = currentVariant();
        var dv = displayVariant();
        if (input && v) input.value = v.id;
        updateOptionsUI();
        updatePrice(dv);
        updateATC();
        updateOffer();
        updateSticky();
        if (changedColor) updateGallery(dv);
        if (v && !initial) updateURL(v);
      }

      // Options
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hs-option] button[data-value]');
        if (!b) return;
        var group = b.closest('[data-hs-option]');
        var idx = Number(group.getAttribute('data-hs-option'));
        opts[idx] = b.getAttribute('data-value');
        group.classList.remove('is-error');
        refresh(idx === colorIndex);
        syncAddons();
      });

      // Produits complémentaires
      sec.addEventListener('change', function (e) {
        var chk = e.target.closest('[data-hs-addon-check]');
        if (chk) {
          var row = chk.closest('[data-hs-addon]');
          row.classList.toggle('is-checked', chk.checked);
          if (chk.checked) syncAddons();
          updateATC(); updateOffer(); updateSticky();
          return;
        }
        var sel = e.target.closest('select[data-hs-addon-variant]');
        if (sel) {
          var r = sel.closest('[data-hs-addon]');
          r.setAttribute('data-user-picked', '');
          var pe = $('[data-hs-addon-price]', r);
          if (pe) pe.textContent = money(addonPrice(r));
          updateATC(); updateOffer(); updateSticky();
        }
      });
      // un clic sur la liste de variantes ne coche/décoche pas la case
      sec.addEventListener('click', function (e) {
        if (e.target.closest('select[data-hs-addon-variant]')) e.stopPropagation();
      }, true);

      function showSizeError() {
        var firstMissing = null;
        $$('[data-hs-option][data-type="size"]', sec).forEach(function (g) {
          var idx = Number(g.getAttribute('data-hs-option'));
          if (!opts[idx]) { g.classList.add('is-error'); if (!firstMissing) firstMissing = g; }
        });
        if (firstMissing) firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      function submit() {
        var v = currentVariant();
        if (!v) { showSizeError(); return; }
        if (!v.available) return;
        var items = [{ id: v.id, quantity: 1 }];
        checkedAddons().forEach(function (row) {
          var el = $('[data-hs-addon-variant]', row);
          if (el && el.value) items.push({ id: el.value, quantity: 1 });
        });
        setBtnState(atc, 'loading');
        if (atcMsg) { atcMsg.textContent = ''; atcMsg.classList.remove('is-ok'); }
        addToCart(items).then(function () {
          setBtnState(atc, 'idle');
          if (atc) atc.textContent = (TXT.added || 'Ajouté') + ' ✓';
          checkedAddons().forEach(function (row) {
            var c = $('[data-hs-addon-check]', row);
            if (c) c.checked = false;
            row.classList.remove('is-checked');
          });
          setTimeout(function () { updateATC(); updateOffer(); updateSticky(); }, 1600);
        }).catch(function (er) {
          setBtnState(atc, 'idle');
          updateATC();
          if (atcMsg) atcMsg.textContent = er.message || TXT.error;
        });
      }

      if (form) {
        form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); submit(); });
      }
      if (sticky) {
        var sbtn = $('[data-hs-sticky-btn]', sticky);
        if (sbtn) sbtn.addEventListener('click', function () {
          if (!currentVariant()) { showSizeError(); return; }
          submit();
        });
        var target = $('[data-hs-atc-wrap]', sec) || atc;
        if (target && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              var show = !en.isIntersecting;
              sticky.classList.toggle('is-visible', show);
              sticky.setAttribute('aria-hidden', String(!show));
              if (sbtn) sbtn.tabIndex = show ? 0 : -1;
            });
          }, { rootMargin: '-56px 0px -80px 0px' });
          io.observe(target);
          document.body.classList.add('hs-has-sticky-atc');
        }
      }

      // Guide des tailles
      sec.addEventListener('click', function (e) {
        var g = e.target.closest('[data-hs-guide-open]');
        if (!g) return;
        var dlg = document.getElementById(sec.getAttribute('data-guide'));
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      });

      // Galerie mobile : points
      var track = $('[data-hs-track]', sec);
      var dots = $$('.hs-gallery__dot', sec);
      if (track && dots.length) {
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
            ticking = false;
          });
        }, { passive: true });
      }

      document.addEventListener('hs:cart-changed', function () { updateOffer(); });

      refresh(false, true);
    });
  }

  /* ---------- Initialisation ---------- */
  function init(root) {
    initAnnounce(root);
    initDelivery(root);
    initTenue(root);
    initProduct(root);
    onScrollHeader();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.Hoopstars = { addToCart: addToCart, money: money, openCart: openCart };
})();